const EXTENSION_PATTERN = /\.[a-z0-9]{2,5}$/i;
const ELLIPSIS = '…';
/** Characters of the name kept right before the extension: they often tell versions apart. */
const TAIL_LENGTH = 5;
const MIN_HEAD_LENGTH = 1;

/**
 * Middle truncation that keeps the extension (PDF or photo is the useful part of a long scan name):
 * `Scansione_Manuale_HACCP_…_firmata.pdf` → `Scansione_Manual…rmata.pdf`.
 */
export function truncateFileName(fileName: string, maxChars: number): string {
  if (fileName.length <= maxChars) {
    return fileName;
  }
  const extension = fileName.match(EXTENSION_PATTERN)?.[0] ?? '';
  const baseName = fileName.slice(0, fileName.length - extension.length);
  const headLength = Math.max(
    MIN_HEAD_LENGTH,
    maxChars - extension.length - ELLIPSIS.length - TAIL_LENGTH,
  );
  if (baseName.length <= headLength + TAIL_LENGTH) {
    return fileName;
  }
  return `${baseName.slice(0, headLength)}${ELLIPSIS}${baseName.slice(-TAIL_LENGTH)}${extension}`;
}
